import React from "react";
import { analytics } from "@heycatch/sdk";

analytics.init({
  projectKey: "hck_pk_NeH-_52UeZjgRcWpncqPkmIpQ0rbJi-k",
  install: {
    framework: "react",
    frameworkVersion: "19",
    agent: "other",
  },
});
import ReactDOM from "react-dom/client";
import axios from "axios";
import { watchFallbackTitle } from './lib/fallbackTitle';
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { setupModuleAccessInterceptor } from "./components/ModuleAccessDenied";

// Service Worker Registration with aggressive update handling
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      // First, unregister any existing service workers to force fresh install
      const existingRegistrations = await navigator.serviceWorker.getRegistrations();
      
      // Check if we need to force update (version mismatch or stale SW)
      const forceUpdate = localStorage.getItem('sw_force_update') === 'true';
      
      if (forceUpdate) {
        console.log('[SW] Force update requested, unregistering all service workers...');
        await Promise.all(existingRegistrations.map(reg => reg.unregister()));
        localStorage.removeItem('sw_force_update');
      }
      
      // Register fresh service worker
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        updateViaCache: 'none' // Always fetch fresh SW from network
      });
      
      console.log('[SW] Service Worker registered:', registration.scope);
      
      // Force update check on registration
      registration.update();
      
      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('[SW] New service worker installing...');
        
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('[SW] New version available, activating...');
            newWorker.postMessage('skipWaiting');
          }
        });
      });
      
      // Reload page when new SW takes control
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          console.log('[SW] Controller changed, reloading page...');
          window.location.reload();
        }
      });
      
    } catch (error) {
      console.error('[SW] Service Worker registration failed:', error);
    }
  }
};

// Register service worker after DOM is ready
if (document.readyState === 'complete') {
  registerServiceWorker();
} else {
  window.addEventListener('load', registerServiceWorker);
}

// Global axios interceptor to add Authorization header from localStorage
// Supports both regular user auth (session_token) and admin auth (admin_session_token)
axios.interceptors.request.use(
  (config) => {
    // Check if this is an admin API request
    const isAdminRequest = config.url && config.url.includes('/api/admin');
    
    if (isAdminRequest) {
      // For admin requests, use admin_session_token
      const adminToken = localStorage.getItem('admin_session_token');
      if (adminToken && !config.headers['Authorization']) {
        config.headers['Authorization'] = `Bearer ${adminToken}`;
      }
    } else {
      // For regular user requests, use session_token
      const token = localStorage.getItem('session_token');
      if (token && !config.headers['Authorization']) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Setup module access denied interceptor
setupModuleAccessInterceptor(axios);

watchFallbackTitle();

// Static head tags serve non-JS fetchers; Helmet owns them once the app runs
document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
